<template>
  <base-container ref="container" style="overflow: hidden">
    <el-row type="flex" style="height: 100%">
      <el-col style="height: 100%" :span="4">
        <artisan-group title="检查资源" border style="height: 100%">
          <el-menu :default-active="resId" @select="selectRes">
            <el-menu-item :index="res.id" v-for="res in resList" :key="res.id">
              <i class="el-icon-menu"></i>
              <span slot="title">{{ res.name }}</span>
            </el-menu-item>
          </el-menu>
        </artisan-group>
      </el-col>
      <el-col style="height: 100%" :span="20" v-loading="loading">
        <el-row type="flex" style="height: 340px" v-loading="loading">
          <el-col :span="12">
            <artisan-calendar
              v-model="scheduleDate"
              ref="calendar"
              @monthChange="monthChange"
            >
              <template slot="dateCell" slot-scope="{ date }">
                <el-row
                  style="position: relative; margin: 2px"
                  :class="getDateClass(date)"
                  type="flex"
                  align="middle"
                >
                  <div
                    :class="date == scheduleDate ? 'date-current' : ''"
                    class="schedule-date"
                  >
                    {{ date.slice(-2) }}
                  </div>
                  <div style="flex: 1" class="align-center color-gray">
                    <div
                      v-if="
                        dayScheduleMap[date] && dayScheduleMap[date].hasSchedule
                      "
                      class="color-info"
                    >
                      <span class="color-success">
                        {{ dayScheduleMap[date].resCount }}
                      </span>
                      <span>/</span>
                      <span>
                        {{ dayScheduleMap[date].totalCount }}
                      </span>
                    </div>
                    <div v-else class="color-gray align-center">--</div>
                  </div>
                  <div
                    v-if="
                      dayScheduleMap[date] &&
                      dayScheduleMap[date].dateType == 'holiday'
                    "
                    class="date-type-flag back-success"
                  >
                    休
                  </div>
                  <div
                    size="mini"
                    v-else-if="
                      dayScheduleMap[date] &&
                      dayScheduleMap[date].dateType == 'adjust'
                    "
                    class="date-type-flag back-danger"
                  >
                    班
                  </div>
                </el-row>
              </template>
            </artisan-calendar>
          </el-col>
          <el-col :span="12" style="overflow-y: auto; background-color: white">
            <artisan-group
              title="时段"
              border
              style="height: 100%"
              v-loading="scheduleLoading"
            >
              <el-row v-if="dateSchedules.length > 0">
                <el-col
                  :span="7"
                  :offset="1"
                  v-for="(schedule, i) in dateSchedules"
                  :key="i"
                  class="padding-v5"
                >
                  <el-radio
                    size="mini"
                    border
                    v-model="scheduleId"
                    :label="schedule.id"
                  >
                    <b>{{ schedule.startPoint }}-{{ schedule.endPoint }}</b>
                    <span>
                      (
                      <b class="color-danger">{{ schedule.resCount }}</b>
                      <span class="padding-h3">/</span>
                      <b class="color-success">{{ schedule.totalCount }}</b>
                      )
                    </span>
                  </el-radio>
                </el-col>
              </el-row>
              <div v-else>
                <el-empty description="暂无排班" :image-size="200"></el-empty>
              </div>
            </artisan-group>
          </el-col>
        </el-row>
        <div style="height: calc(100% - 340px)">
          <ArtisanGrid
            v-if="resId"
            size="mini"
            ref="record"
            :query="{ reserveDate: scheduleDate, resourceId: resId }"
            style="height: 100%"
            metaKey="JcApplyBill"
            @row-dblclick="showBillDetail"
          >
            <template #patientName="{ row }">
              <el-button type="text" @click="showBillDetail(row)">{{
                row.patientName
              }}</el-button>
            </template>
            <template #status="{ row, label }">
              <el-tag :type="statusType[row.status]" effect="dark" size="small">
                {{ label }}
              </el-tag>
            </template>
            <template #period="{ row }">
              {{ row.startPoint }}-{{ row.endPoint }}
            </template>
            <template #operation>
              <el-table-column
                :width="80"
                label="操作"
                fixed="right"
                align="center"
                class-name="back-white"
              >
                <template slot-scope="{ row }">
                  <el-button
                    v-if="row.status == 'ok'"
                    type="text"
                    class="color-success"
                    icon="el-icon-success"
                    size="mini"
                    @click="signBill(row)"
                  >
                    签到
                  </el-button>
                </template>
              </el-table-column>
            </template>
          </ArtisanGrid>
        </div>
      </el-col>
    </el-row>
    <artisan-dialog
      :title="dialog.title"
      :visible.sync="dialog.show"
      height="80%"
      width="80%"
    >
      <RecordDetail
        v-if="dialog.show"
        :query="{ recordId: dialog.billId }"
      ></RecordDetail>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { loadSchedule } from "@/api/jc/schedule";
import { getAuthResource, getResSchedulesOfDate } from "@/api/jc/reserve";
import moment from "moment";
import RecordDetail from "./RecordDetail.vue";
import { getCalendarInfo } from "@/util/util";
import { sign } from "@/api/jc/reserve";
export default {
  components: { RecordDetail },
  data() {
    return {
      loading: false,
      scheduleLoading: false,
      statusType: {
        wait: "info",
        ok: "primary",
        cancel: "warning",
        scrap: "danger",
        stop: "danger",
        sign: "success",
        check: "success",
        report: "success",
        undo: "danger",
      },
      resId: "",
      resList: [],
      schedules: [],
      scheduleDate: moment().format("YYYY-MM-DD"),
      scheduleId: "",
      dateSchedules: [],
      dialog: {
        title: "",
        show: false,
        billId: "",
      },
    };
  },
  computed: {
    dayScheduleMap() {
      let scheduleMap = {};
      this.schedules.forEach((c) => {
        scheduleMap[c.scheduleDate] = c;
      });
      return scheduleMap;
    },
  },
  watch: {
    scheduleDate() {
      this.$refs.record.reload({
        resourceId: this.resId,
        reserveDate: this.scheduleDate,
        scheduleId: "",
      });
      this.loadResSheduleOfDate();
    },
    scheduleId() {
      this.$refs.record.reload({ scheduleId: this.scheduleId });
    },
  },
  created() {
    this.loadResources();
  },
  methods: {
    loadResources() {
      getAuthResource()
        .then((res) => {
          this.resList = res.data.data;
          if (this.resList.length) {
            this.resId = this.resList[0].id;
            let { start, end } = getCalendarInfo(this.scheduleDate);
            this.loadSchedules(start, end);
          }
        })
        .catch(() => {});
    },
    loadSchedules(start, end) {
      this.loading = true;
      loadSchedule(this.resId, start, end)
        .then((res) => {
          let data = res.data.data;
          this.schedules = data;
          this.loading = false;
          this.loadResSheduleOfDate();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    loadResSheduleOfDate() {
      if (
        this.dayScheduleMap[this.scheduleDate] &&
        this.dayScheduleMap[this.scheduleDate].hasSchedule
      ) {
        this.scheduleLoading = true;
        getResSchedulesOfDate(this.resId, this.scheduleDate)
          .then((res) => {
            this.dateSchedules = res.data.data;
            this.scheduleLoading = false;
          })
          .catch(() => {
            this.scheduleLoading = false;
          });
      } else {
        this.dateSchedules = [];
      }
    },
    monthChange({ start, end }) {
      this.loadSchedule(start, end);
    },
    getDateClass(date) {
      let now = moment().format("YYYY-MM-DD");
      if (this.dayScheduleMap[date] && this.dayScheduleMap[date].hasSchedule) {
        return date >= now ? "back-success-light" : "back-info-light";
      }
      return "";
    },
    selectRes(index) {
      this.resId = index;
      this.scheduleId = "";
      let { start, end } = getCalendarInfo(this.scheduleDate);
      this.loadSchedules(start, end);
      this.$refs.record.reload({
        resourceId: this.resId,
        reserveDate: this.scheduleDate,
      });
    },
    showBillDetail(row) {
      this.dialog.title = `预约申请单详情--${row.patientName}(${row.id})`;
      this.dialog.billId = row.id;
      this.dialog.show = true;
    },
    signBill(row) {
      this.$refs.container.confirm({ msg: "确认签到？" }).then(() => {
        this.loading = true;
        sign({ billId: row.id })
          .then(() => {
            this.$message({
              type: "success",
              message: "签到成功！",
            });
            this.loading = false;
            this.$refs.record.loadData();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.schedule-date {
  height: 30px;
  line-height: 30px;
  width: 30px;
  font-size: 1.2rem;
  margin: 8px 0 8px 3px;
  text-align: center;
}
.date-current {
  border-radius: 50%;
  background-color: #409eff;
  color: white;
  text-align: center;
}
.date-type-flag {
  position: absolute;
  right: 0;
  top: 0;
  height: 16px;
  width: 16px;
  text-align: center;
  line-height: 16px;
  font-size: 0.7rem;
  border-radius: 5px;
  color: white;
}
</style>
